import { Col, FlexView, Row } from '@cuemath/comps';
import React from 'react';
import { MAPPING_FILTERS_TYPES } from 'constants/ac-led-mapping';
import { Button, Dropdown } from '@cuemath/web-comps';
import styled from 'styled-components';
import useLogic from './MappingFilters.logic';
import PropTypes from 'prop-types';
import DateTimeComponent from '../../v2/datetime-picker';

const FilterItem = styled(Col)`
  max-height: 52px;
  margin-right: 16px;
`;

const filterMapper = {
  [MAPPING_FILTERS_TYPES.DROPDOWN]: ({
    label,
    options,
    code,
    value,
    handleChange,
    isRequired,
  }) => (
    <Dropdown
      onChange={value => handleChange({ key: code, value })}
      label={isRequired ? `${label}*` : label}
      value={value}
      options={options?.map(option => ({ ...option, id: option?.value }))}
      optionsWidth="200px"
      height="auto"
      width="200px"
      type="primary"
    />
  ),
};

const MappingFilters = ({
  isSearchProcessing,
  showDateTimeFilter,
  timezone,
  handleChange,
  filters,
  handleSearchTeachers,
  configKey,
  dateTimePreset,
  handleChangeDateTime,
  showAddSlotButton,
  handleAddNewSlot,
  handleRemoveSlot,
  mapperType,
}) => {
  const { mappingFilters, isDisabled } = useLogic({
    filters,
    configKey,
    mapperType,
    dateTimePreset,
  });

  return (
    <Row alignItems="baseline">
      {mappingFilters?.map(({ type, label, code, options, is_required }) => (
        <FilterItem key={code} gutter={0}>
          {filterMapper?.[type]?.({
            label,
            options,
            code,
            value: filters?.[code] ?? '',
            handleChange,
            isRequired: is_required,
          })}
        </FilterItem>
      ))}

      {showDateTimeFilter && (
        <DateTimeComponent
          timezone={timezone}
          dateTimePreset={dateTimePreset}
          handleChangeDateTime={handleChangeDateTime}
          showAddSlotButton={showAddSlotButton}
          handleAddNewSlot={handleAddNewSlot}
          handleRemoveSlot={handleRemoveSlot}
        />
      )}
      {mappingFilters?.length > 0 && (
        <Col gutter={0} gap={16}>
          <Button
            label="Search Teacher"
            isBusy={isSearchProcessing}
            onClick={handleSearchTeachers}
            isDisabled={isDisabled}
            size="small"
          />
        </Col>
      )}
    </Row>
  );
};

MappingFilters.propTypes = {
  isSearchProcessing: PropTypes.bool,
  handleChange: PropTypes.func,
  filters: PropTypes.shape({}),
  handleSearchTeachers: PropTypes.func,
  configKey: PropTypes.string,
};

export default MappingFilters;
